import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import FormButton from "components/form/FormButton";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  itemName?: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  itemName,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          minWidth: { xs: "300px", sm: "450px" },
          minHeight: { xs: "120px", sm: "200px" },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
          {itemName && <strong> {itemName}</strong>}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <FormButton
          label={cancelLabel}
          onSubmit={onCancel}
          variant="outlined"
          inline={true}
        />
        <FormButton
          label={confirmLabel}
          onSubmit={onConfirm}
          variant="contained"
          color="error"
          inline={true}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
